import logging from '@wr/logging';
import {getErrorStatusCode} from '../components/pages/PoliStatusWaiting/helpers';
import config from '../config';
import eventIds from '../event-ids';
import {throwOnResponseError} from '../utils/createResponseError';
import {getPaymentSessionId} from '../utils/helpers';

const getTabapayCardDetails = async ({
    sessionId, requestId, params, query
}) => {
    const paymentSessionId = getPaymentSessionId(params, query);
    const logger = logging.createLogger(config.app.name, config.logger.logServerUrl);
    const logProps = {requestId, sessionId, paymentSessionId};

    logger.info('Retrieving Tabapay card details', {
        eventId: eventIds['Retrieving Tabapay card details'],
        ...logProps
    });

    try {
        const url = new URL(`/api/sessions/${paymentSessionId}/card`, config.tabapayIntegrator.url);

        const initResponse = await fetch(url.toString());

        throwOnResponseError(initResponse);

        const cardDetails = await initResponse.json();

        logger.info('Retrieved Tabapay card details', {
            eventId: eventIds['Retrieved Tabapay card details'],
            ...logProps,
            payload: cardDetails
        });

        return cardDetails;
    } catch (e) {
        const error = new Error(`Error retrieving Tabapay card details: ${e.message}`);

        error.status = getErrorStatusCode(e);

        logger.error(error.message, {
            eventId: eventIds['Error retrieving Tabapay card details'],
            ...logProps
        });

        throw error;
    }
};

export default getTabapayCardDetails;
